/**
 * Checks if a user is an Atlassian employee based on their email domain.
 *
 * @param email - User's email address
 * @returns true if the email is from an Atlassian domain, false otherwise
 */
export const isAtlassianEmployee = (email?: string): boolean => {
	if (!email) {
		return false;
	}

	return email.toLowerCase().endsWith('@atlassian.com');
};
